module.exports = __webpack_public_path__ + "static/media/phone.bd69cc32.png";